import { render, staticRenderFns } from "./ProposedHolderCN.vue?vue&type=template&id=11842320"
import script from "./ProposedHolderCN.vue?vue&type=script&lang=js"
export * from "./ProposedHolderCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports